// import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';
import deps from './deps';
import ProductGroupsTreeGrid from './tree-product-groups-grid';
import ProductGroupsFlattenGrid from './flatten-product-groups-grid';
import { getConfig } from './grid-config';
import { getPlugins } from './grid-plugins-config';

export function createProductGroupsGrid({
  gridName,
  router,
  campaign,
  adgroup,
  level,
  gridParameters,
  callbacks,
  triggerScrollbarReposition = null,
  filterService,
  preferenceConfig,
  viewport,
  getAdditionalPlugins,
  customHeaderOffset,
  isTreeView = true,
  p$daterange = null,
  perfMarker,
  activityLogger,
}) {
  const currentScope = deps.treeView.edmCampaign.currentAdGroup
    || deps.treeView.edmCampaign.currentCampaign || deps.treeView.edmCampaign.currentAccount;
  const dataSource = {
    type: 'jsdata',
    entity: deps.treeView.jsData.ProductGroup,
    schema: deps.treeView.s$ProductGroup,
    options: {
      entitySet: currentScope
        .ProductGroups['Default.GridData'].$call({
          gridDataParameters: {},
          isAdGroupTreeView: isTreeView,
        }),
      cacheResponse: false,
    },
  };
  if (isTreeView) {
    return new ProductGroupsTreeGrid({
      gridName,
      router,
      dataSource,
      deps: deps.treeView,
      campaign,
      adgroup,
      level,
      gridParameters,
      callbacks,
      triggerScrollbarReposition,
      filterService,
      preferenceConfig,
      // setupDataSourceErrorHandling: view => setUpErrorHandling({
      //   gridView: view,
      //   scope,
      //   dataSource,
      //   i18n,
      // }),
      getGridConfig: view => getConfig({
        view,
        filterService,
        deps: deps.treeView,
        isTreeView,
        dataSource,
        viewport,
        customHeaderOffset,
      }),
      getGridPlugins: view => getPlugins({
        view,
        filterService,
        deps: deps.treeView,
        isTreeView,
        p$daterange,
        perfMarker,
      }).concat(getAdditionalPlugins(view)),
      activityLogger,
      perfMarker,
    });
  }

  return new ProductGroupsFlattenGrid({
    gridName,
    router,
    dataSource,
    deps: deps.flattenView,
    campaign,
    adgroup,
    level,
    gridParameters,
    callbacks,
    triggerScrollbarReposition,
    filterService,
    preferenceConfig,
    // setupDataSourceErrorHandling: view => setUpErrorHandling({
    //   gridView: view,
    //   scope,
    //   dataSource,
    //   i18n,
    // }),
    getGridConfig: view => getConfig({
      view,
      filterService,
      deps: deps.flattenView,
      isTreeView,
      dataSource,
      viewport,
      customHeaderOffset,
    }),
    getGridPlugins: view => getPlugins({
      view,
      filterService,
      deps: deps.flattenView,
      isTreeView,
      p$daterange,
      perfMarker,
    }).concat(getAdditionalPlugins(view)),
    activityLogger,
    perfMarker,
  });
}
